import { render, staticRenderFns } from "./DocumentListing.vue?vue&type=template&id=92c6ae3c&scoped=true"
import script from "./DocumentListing.vue?vue&type=script&lang=js"
export * from "./DocumentListing.vue?vue&type=script&lang=js"
import style0 from "./DocumentListing.vue?vue&type=style&index=0&id=92c6ae3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92c6ae3c",
  null
  
)

export default component.exports